import { render, staticRenderFns } from "./ButtonBase.vue?vue&type=template&id=67490cfc&scoped=true"
import script from "./ButtonBase.vue?vue&type=script&lang=js"
export * from "./ButtonBase.vue?vue&type=script&lang=js"
import style0 from "./ButtonBase.vue?vue&type=style&index=0&id=67490cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67490cfc",
  null
  
)

export default component.exports